export default (promise, defaultValue) => promise.catch(() => defaultValue);
